import { render, staticRenderFns } from "./InventoryReplenishment.vue?vue&type=template&id=a3ae484c&"
import script from "./InventoryReplenishment.vue?vue&type=script&lang=js&"
export * from "./InventoryReplenishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports